'use client';

import InfoIconModal from '@/components/infoIcon/InfoIconModal';
import { SwdSwitch } from '@/components/swdSwitch/SwdSwitch';
import classNames from 'classnames';
import type { MouseEvent } from 'react';

import classes from './EcoSwitch.module.scss';

export interface EcoSwitchProps {
  heading: string;
  subtext?: string;
  ecoInfo?: string;
  checked: boolean;
  onSwitchClick: () => void;
}

const EcoSwitch: React.FC<EcoSwitchProps> = ({ heading, subtext, ecoInfo, checked, onSwitchClick }) => {
  const handleSurfaceClick = (event: MouseEvent<HTMLDivElement>): void => {
    const target = event.target as HTMLElement;
    if (target.closest('[data-testid="info-icon-button"]') || target.closest('[data-slot="switch"]')) {
      return;
    }
    onSwitchClick();
  };

  return (
    <div className={classNames(classes.ecoSwitch, checked ? classes.checked : '')}>
      <div className={classes.switchWrapper} onClick={handleSurfaceClick}>
        <div className={classes.control}>
          <span className={classes.switchSlot}>
            <SwdSwitch
              aria-label={heading}
              checked={checked}
              className={classes.switch}
              data-testid="eco-switch-button"
              onChange={() => onSwitchClick()}
            />
          </span>
          <span className={classes.heading}>{heading}</span>
          {!!ecoInfo && (
            <span className={classes.info}>
              <InfoIconModal trackingLabel={heading} size={24}>
                {ecoInfo}
              </InfoIconModal>
            </span>
          )}
        </div>
      </div>
      {!!subtext && <div className={classNames('font-label-small', classes.subtext)}>{subtext}</div>}
    </div>
  );
};

export default EcoSwitch;
